export const onTextChange = (key, data, setValue) => {
  setValue((draft) => {
    draft[key] = data;
  });
};

export const validate = (key, value, setHelperText) => {
  const _value = value[key];
  const _number = Number(_value);
  if (_value === null || _value == "") {
    setHelperText((draft) => {
      draft[key] = "This field is required";
    });
  } else if (
    ["loanToValue", "liquidationThreshold", "reserveFactor", "liquidationBonus"].includes(key) &&
    (_number > 1 || _number < 0)
  ) {
    setHelperText((draft) => {
      draft[key] = "This field must be less than 1 and greater than 0";
    });
  } else if (_value < 0) {
    setHelperText((draft) => {
      draft[key] = "This field must be greater than 0";
    });
  } else
    setHelperText((draft) => {
      draft[key] = null;
    });
};
